import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-reward-bifurcation',
  templateUrl: './reward-bifurcation.component.html',
  styleUrls: ['./reward-bifurcation.component.scss']
})
export class RewardBifurcationComponent implements OnInit {
  @Output() rewardBifurData: EventEmitter<boolean> = new EventEmitter;

  bname = "|||||||||||||||||||||||||||||||||||||||||||||||||||";
  hname = "|||||||||||||||||||||||||||||||||||||||||||||||||||";
  addRewardFlag: boolean = true;
  formGroup: FormGroup;
  otherRewardList: FormArray;
  rewardsArray:any;
  excelData:any = [];
  uploadedExcelData:any ;
  updateModal:any ={
    notification:'',
    app_success:''
  }
  campaign_id:any = '';
  notificationField:any=''
  notificationFieldList:any=[]
  validData:any;
  type:any ;
  cartonLocalDetail : any = {};
  testFlag = true
  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private apiconfig: ApiConfiguration,
    private exportExcelService: ExportExcelService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private xlsx: XlsxService,
    private toast: ToastClientService,

  ) {
  }
  rewards:any = {
    mega:[],
    physial_rewards:[],
    points:[],
    e_voucher:[],
    others:[]
  }
  id:any=0;

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get("id");
    this.type = this.activatedRoute.snapshot.paramMap.get("type");
    this.campaign_id = this.activatedRoute.snapshot.paramMap.get("cartonid")
    this.cartonLocalDetail = JSON.parse(localStorage.getItem('cartonFlgs'))
    this.form();
    this.getRewardBifurcationData();
    this.getRewardBrands();
    debugger
    // this.getFields()
  }
  // ngDoCheck() {
  //   if(this.cartonLocalDetail.type2Whitelist) {
  //     this.getRewardBifurcationData();
  //   }
  // }

  form(){
    let data:any = {
      reward_type: '',
      reward_id: '',
      app_success: '',
      no_of_voucher: 0,
      notification: '',
      template_id: '',
      sms: '',
      excel_data: '',
    }
    console.log("cartonFlags",this.cartonLocalDetail.type2Whitelist)
    if(this.id != 0){
      if(this.cartonLocalDetail.whiteListFlag){
        this.formGroup = this.fb.group({
          other_rewards: this.fb.array([]),
        });
      }else{
        this.formGroup = this.fb.group({
          other_rewards: this.fb.array([this.createOtherReward(data)]),
        });

      }
    }
    else{
      this.formGroup = this.fb.group({
        other_rewards: this.fb.array([this.createOtherReward(data)]),
      });
  }

    this.otherRewardList = this.formGroup.get('other_rewards') as FormArray;
  }
  get otherRewardFormgroup() {
    return this.formGroup.get('other_rewards') as FormArray;
  }
  getOtherRewardFormgroup(i): FormGroup {
    console.log("hello")
    const formGroup = this.otherRewardList.controls[i] as FormGroup;
    return formGroup;
  }
  bannerImage(e) {
    console.log(e)
    this.bname = e.target.files[0].name;
  }
  homePageImage(e) {
    this.hname = e.target.files[0].name;
  }
  addRewards() {
    this.addRewardFlag = false;
  }
  createOtherReward(data): FormGroup {
    console.log("fasfadd",data)
    if(this.cartonLocalDetail.rewardBifurcation){
      return this.rewardsArray= this.fb.group({
        reward_type: new FormControl(data.reward_type, [Validators.required]),
        reward_id: new FormControl(data.reward_id, [Validators.required]),
        no_of_voucher: new FormControl(0, [Validators.required]),
        excel_data: new FormControl(''),
        app_success: new FormControl(data.app_success, [Validators.required]),
        notification: new FormControl(data.notification, [Validators.required]),
        template_id: new FormControl(data.template_id),
        sms: new FormControl(data.sms),
        notificatioFiled:new FormControl(""),
        smsField: new FormControl(""),
        app_successField: new FormControl(""),
        app_select_box : new FormControl(''),
        type_select_box: new FormControl(''),
        disableField:new FormControl(data.disableField),
        id: new FormControl(data.id),
        existNoofVoucher: new FormControl(data.no_of_voucher)
      });
    }else{
      return this.rewardsArray= this.fb.group({
        reward_type: new FormControl(data.reward_type, [Validators.required]),
        reward_id: new FormControl(data.reward_id, [Validators.required]),
        no_of_voucher: new FormControl(data.no_of_voucher, [Validators.required]),
        excel_data: new FormControl(''),
        app_success: new FormControl(data.app_success, [Validators.required]),
        notification: new FormControl(data.notification, [Validators.required]),
        template_id: new FormControl(data.template_id),
        sms: new FormControl(data.sms),
        notificatioFiled:new FormControl(""),
        smsField: new FormControl(""),
        app_successField: new FormControl(""),
        app_select_box : new FormControl(''),
        type_select_box: new FormControl(''),
        disableField:new FormControl(false),
        existNoofVoucher: new FormControl('0')

      });
    }
  }
  messageField:any= {}
  isEdit:boolean = false;
  getRewardBifurcationData(){
    this.apiService.get(this.apiconfig.getrewardBifurcation+`?campaign_id=${this.campaign_id}&parameter=1`).subscribe((res:any)=>{
      console.log("other reward list", res.data)
      let payload = res.data;
      let obj:any = {
        reward_type: '',
        reward_id: '',
        app_success: '',
        no_of_voucher: 0,
        notification: '',
        template_id: '',
        sms: '',
        excel_data: '',
        disableField: false
      }
      if(this.id !=0 || this.cartonLocalDetail.rewardBifurcation){
        payload.forEach((e , i)=>{
          console.log("xcvbnm",e)
          obj.reward_type = e.reward_type;
          obj.reward_id = e.carttype_rewards_id
          obj.app_success=e.app_success_text
          obj.no_of_voucher=e.no_of_vouchers
          obj.notification=e.notification_text
          obj.template_id=e.template_id
          obj.sms=e.message_text
          obj.excel_data='';
          obj.id = e.id;
          obj.disableField = true
          this.addOtherReward(obj)
          this.getFields(e.reward_type , i)
          this.subReward(e.reward_type,i)
          this.getreadRewards(e.reward_type,this.activatedRoute.snapshot.paramMap.get("type"),i)
          // this.existDataDownload(e.id);
          if(this.cartonLocalDetail.rewardBifurcation){
            this.isEdit = true;
            // this.formGroup.controls.other_rewards['controls'][i].controls['reward_type'].disable()
            // this.formGroup.controls.other_rewards['controls'][i].controls['reward_id'].disable()
          }
        },err =>{
          this.addOtherReward(obj)
        })
      }else{
        let data:any = {
          reward_type: '',
          reward_id: '',
          app_success: '',
          no_of_voucher: 0,
          notification: '',
          template_id: '',
          sms: '',
          excel_data: '',
        }
        // this.addOtherReward(data)
      }
    })
  }
  existDataUrl:any;
  existDataDownload(id){
    this.apiService.get(this.apiconfig.existingExcelData+`?carton_reward_id=${id}&carton_campaign_id=${this.campaign_id}`).subscribe((res:any)=>{
       let url =res.data.URL
       window.open(url, '_self');
    })
  }

  callAddOtherReward(){
    let data:any = {
      reward_type: '',
      reward_id: '',
      app_success: '',
      no_of_voucher: '',
      notification: '',
      template_id: '',
      sms: '',
      excel_data: '',
      disableField:false
    }

    this.addOtherReward(data)

  }
  // ADD Other Reward
  addOtherReward(data) {
    this.isEdit = false;
    if(this.id== 0){
      data={
        reward_type: '',
        reward_id: '',
        app_success: '',
        no_of_voucher: '',
        notification: '',
        template_id: '',
        sms: '',
        excel_data: '',
      }
    }
    this.otherRewardList.push(this.createOtherReward(data));
    this.addRewardFlag = false;
  }
  removeOtherReward(i) {
    console.log(this.otherRewardList.length)
    this.toast.Success("Removed Successfully.")
    this.otherRewardList.removeAt(this.otherRewardList.length-1);
  }
  uploadExcel(e,r_id,no_of_voucher,formData,modal,i){
    let file = e.target.files[0]
    console.log(no_of_voucher,formData)
    this.excelFileUpload(e,r_id,no_of_voucher,file,modal,i);
  }
  getExcel(file){
   this.rewardsArray.controls['excel_data'].value = file
    console.log("hello",this.formGroup.value)
    return
  }
  excelFileUpload(e,r_id,no_voucher,excelFile,modal,i){
    console.log("vouchers",no_voucher)
    let voucher = no_voucher
    let fileLength:any = ''
    let file:any = ''
    this.xlsx.uploadXlsx(e).then((res: any) => {
      console.log("Excel Data",res.data.length)
      file = res.data
      this.rewardsArray.controls.excel_data.setValue(res.data);
      this.getExcel(res.data);
      fileLength = res.data.length;
      if(voucher === fileLength){
        let payload = new FormData();
        payload.append('reward_id',r_id);
        payload.append('no_of_voucher',no_voucher)
        payload.append('excel',excelFile)
        this.apiService.uploadFile(this.apiconfig.excelFile,payload).subscribe((res:any)=>{
          console.log(res)
          try{
            this.uploadedExcelData = res.body.data
            console.log("upload", this.uploadedExcelData)
            if(this.uploadedExcelData != 0 || this.uploadedExcelData != undefined){
              console.log(this.uploadedExcelData)
              this.modalService.open(modal, {
                centered: true,
                backdrop: "static",
                size:"lg"
              });
              if(this.uploadedExcelData.total_valid_codes != 0){
                // this.formGroup.controls.other_rewards['controls'][i].controls.disableField.setValue(true);
              }
            }
          }
          catch{}

        })
      }else{
        this.toast.Error("No of vouchers and excel data is mismatched");
      }
    })
  }
  reward_type:any = '';
  selectRewardtype(e){
    this.reward_type = e
    console.log(e)
  }
  validCount:any ='';
  invalidCount:any ='';
  invalidCountData:any=[] ;
  resData:any;



  submit(value, modal,i) {
    console.log(this.otherRewardList)
    let campaginId;
    if(this.id != 0){
      campaginId = this.campaign_id;
    }else{
      campaginId = localStorage.getItem('type2_campaign_id');
    }
    let payload ={
      campaign_id:campaginId,
      rewards:{
        mega:[],
        physical_reward:[],
        points:[],
        e_voucher:[],
        other:[]
      }
    }
    value.other_rewards.forEach((e : any) => {
      e.reward_type == 1 && payload.rewards.e_voucher.push(e)
      e.reward_type == 2 && payload.rewards.physical_reward.push(e)
      e.reward_type == 3 && payload.rewards.mega.push(e)
      e.reward_type == 4 && payload.rewards.points.push(e)
    });
    if(this.formGroup.invalid){
      this.toast.Error("fill required fields")
      return;
    }else{
      if (this.cartonLocalDetail.whiteListFlag) {
        this.apiService.post(this.apiconfig.updateReward_Bifur, payload).subscribe((res: any) => {
          console.log(res)
          this.resData = res.body;
          if (this.resData.data.reward_bifurcation) {
            this.toast.Success(res.body.data.message)
            this.validCount = res.body.data.total_valid_codes
            this.invalidCount = res.body.data.total_invalid_codes
            this.invalidCountData = res.body.data.invalid_codes
            this.modalService.open(modal, {
              centered: true,
              backdrop: "static",
              size: "lg"
            });
            this.cartonLocalDetail = { ...this.cartonLocalDetail, whiteListFlag: true }
            localStorage.setItem('cartonFlgs', JSON.stringify(this.cartonLocalDetail))
            this.rewardBifurData.emit(true)
          }
          else {
            this.toast.Error(res.body.data.message)
            this.validCount = res.body.data.total_valid_codes
            this.invalidCount = res.body.data.total_invalid_codes
            this.invalidCountData = res.body.data.invalid_codes
            this.modalService.open(modal, {
              centered: true,
              backdrop: "static",
              size:"lg"
            });
            this.cartonLocalDetail = { ...this.cartonLocalDetail, whiteListFlag: true }
            localStorage.setItem('cartonFlgs', JSON.stringify(this.cartonLocalDetail))
            this.rewardBifurData.emit(true)
            this.toast.Error(res.body.data.message)
          }
        },err=>{
          console.log('err',err)
          this.toast.Error(err)
        })
      }else{
        this.apiService.post(this.apiconfig.rewardBifurcation,payload).subscribe((res:any)=>{
          console.log(res)
          this.resData = res.body;
          debugger
          if(this.resData.data.reward_bifurcation){
            this.toast.Success(res.body.data.message)
              this.validCount = res.body.data.total_valid_codes
              this.invalidCount = res.body.data.total_invalid_codes
              this.invalidCountData = res.body.data.invalid_codes
              this.modalService.open(modal, {
                centered: true,
                backdrop: "static",
                size:"lg"
              });
            this.cartonLocalDetail = { ...this.cartonLocalDetail , whiteListFlag : true}
            localStorage.setItem('cartonFlgs' , JSON.stringify(this.cartonLocalDetail))
            this.rewardBifurData.emit(true)
          }
          else{
            this.toast.Error(res.body.data.message)
            this.validCount = res.body.data.total_valid_codes
            this.invalidCount = res.body.data.total_invalid_codes
            this.invalidCountData = res.body.data.invalid_codes
            this.modalService.open(modal, {
              centered: true,
              backdrop: "static",
              size:"lg"
            });
            this.cartonLocalDetail = { ...this.cartonLocalDetail , whiteListFlag : false}
            localStorage.setItem('cartonFlgs' , JSON.stringify(this.cartonLocalDetail))
            this.rewardBifurData.emit(false)
            this.toast.Error(res.body.data.message)
          }
        },err=>{
          console.log('err',err)
          this.toast.Error(err)
        })
      }
    }
  }


  dismissSubmitModal(flag){
    console.log("hello", flag)
    this.modalService.dismissAll()

    // if(flag.data.reward_bifurcation){
    //   console.log("hello")
    //   this.toast.Success(flag.data.message)
    //   this.cartonLocalDetail = { ...this.cartonLocalDetail , whiteListFlag : true}
    //   localStorage.setItem('cartonFlgs' , this.cartonLocalDetail)
    //   this.rewardBifurData.emit(true)
    //   this.modalService.dismissAll()
    // }else{
    //   this.toast.Error(flag.data.message)
    //   if(this.cartonLocalDetail.whiteListFlag){
    //     debugger
    //     this.cartonLocalDetail = { ...this.cartonLocalDetail , whiteListFlag : true}
    //     localStorage.setItem('cartonFlgs' , this.cartonLocalDetail)
    //     this.rewardBifurData.emit(true)
    //     }else{
    //       debugger
    //       this.cartonLocalDetail = { ...this.cartonLocalDetail , whiteListFlag : false}
    //       localStorage.setItem('cartonFlgs' , this.cartonLocalDetail)
    //       this.rewardBifurData.emit()
    //     }
    //   this.modalService.dismissAll()
    // }
  }
  invalidExcel(data){
    console.log(data)
    this.xlsx.export(data,"Invalid codes")
  }

  downloadInvalidExcel(data){
    console.log(data)
    this.xlsx.export(data,"Invalid codes")
  }
  dismissModal(){
    this.modalService.dismissAll();
  }
  rewardBrands:any=[];
  getRewardBrands(){
    this.apiService.get(this.apiconfig.rewardBrands+`?module_id=1`).subscribe((res:any)=>{
      console.log("rewards mega" , res.data)
      this.rewardBrands = res.data;
    })
  }
  rewardTypes:any =[]
  getreadRewards(e,type,i){
    debugger
    console.log("qwertyuiffhsdfhdsfsfhsdfsd",e)
    this.apiService.get(this.apiconfig.rewardTypes+`?program_id=1&reward_type=${e}&id=1`).subscribe((res:any)=>{
      this.rewardTypes = res.data;
      if(e == 1){
        this.formGroup.controls.other_rewards['controls'][i].patchValue({
          type_select_box : res.data
        })
        console.log(this.formGroup.controls.other_rewards['controls'][i].controls.type_select_box.value)
      }
      if(e == 2){
        this.formGroup.controls.other_rewards['controls'][i].patchValue({
          type_select_box : res.data
        })
        console.log(this.formGroup.controls.other_rewards['controls'][i].controls.type_select_box.value)
      }
      if(e == 3){
        debugger
        console.log(this.formGroup.controls.other_rewards['controls'])
        if (i >= 0 && i < this.formGroup.controls.other_rewards['controls'].length) {
          this.formGroup.controls.other_rewards['controls'][i].controls.type_select_box.setValue(res.data);
        } else {
          this.formGroup.controls.other_rewards['controls'][i].patchValue({
            type_select_box: res.data
          });
        }
        // this.formGroup.controls.other_rewards['controls'][i].patchValue({
        //   type_select_box : res.data
        // })

        console.log(this.formGroup.controls.other_rewards['controls'][i].controls.type_select_box.value)

      }
      if(e == 4){
        this.formGroup.controls.other_rewards['controls'][i].patchValue({
          type_select_box : res.data
        })
        console.log(this.formGroup.controls.other_rewards['controls'][i].controls.type_select_box.value)
      }
    })
  }
  rewardTypeField:any = ''
  getRewardBrand(e , i){
    this.getreadRewards(e,this.activatedRoute.snapshot.paramMap.get("type"),i)
    this.rewardTypeField = e;
    // console.log(this.formGroup.controls.other_rewards['controls'][i].controls.app_select_box.value)
    this.getFields(e , i)


  }
  cursor_point: any = "";
  cursorEvent(oField) {
    if (oField.selectionStart || oField.selectionStart == '0') {
      let caretPos = oField.selectionStart;
      this.cursor_point = caretPos;
    }
  }

  appendDynamicDataInMsg(field,message, num) {
    if (num == 1) {
      if (!field) {
        this.toast.Error("Select the value")
        return
      }
      let leng = message.length;
      if (leng == this.cursor_point) {
      } else {
        if (this.cursor_point) {
          var firstText = this.rewardsArray.value.app_success.substr(0, this.cursor_point); // Gets the first part
          var secoundText = this.rewardsArray.value.app_success.substr(this.cursor_point); // Gets the secound part
          this.rewardsArray.controls.app_success.setValue(firstText + field + secoundText);
        } else {
          this.rewardsArray.controls.app_success.setValue(this.rewardsArray.value.app_success +field) ;
        }
      }

    } else if (num == 2) {
      if (!field) {
        this.toast.Error("Select the value")
        return
      }
      let leng = message.length;
      if (leng == this.cursor_point) {
      } else {
        if (this.cursor_point) {
          var firstText = this.rewardsArray.value.notification.substr(0, this.cursor_point); // Gets the first part
          var secoundText = this.rewardsArray.value.notification.substr(this.cursor_point); // Gets the secound part
          this.rewardsArray.controls.notification.setValue(firstText + field + secoundText) ;
        } else {
          this.rewardsArray.controls.notification.setValue(this.rewardsArray.value.notification +field) ;
        }
      }
    } else if (num == 3) {
      if (!field) {
        this.toast.Error("Select the value")
        return
      }
      let leng = message.length;
      if (leng != this.cursor_point) {
      } else {
        if (this.cursor_point) {
          var firstText = this.rewardsArray.value.sms.substr(0, this.cursor_point); // Gets the first part
          var secoundText = this.rewardsArray.value.sms.substr(this.cursor_point); // Gets the secound part
          this.rewardsArray.controls.sms.setValue(firstText + field + secoundText) ;
          console.log(this.rewardsArray.value.sms)
        } else {
          this.rewardsArray.controls.sms.setValue(this.rewardsArray.value.sms +field) ;
          console.log(this.rewardsArray.value.sms)

        }
      }
    }
  }
  getFields(e , i){
    this.apiService.get(this.apiconfig.getfields).subscribe((res:any)=>{
      console.log(res);
      if(e == 1){
        this.formGroup.controls.other_rewards['controls'][i].patchValue({
          app_select_box : res.data.e_voucher
        })
      }
      if(e == 2){
        this.formGroup.controls.other_rewards['controls'][i].patchValue({
          app_select_box : res.data.physical_voucher
        })
      }
      if(e == 3){
        this.formGroup.controls.other_rewards['controls'][i].patchValue({
          app_select_box : res.data.mega
        })
      }
      if(e == 4){
        this.formGroup.controls.other_rewards['controls'][i].patchValue({
          app_select_box : res.data.points
        })
        console.log("points............",this.formGroup.controls.other_rewards['controls'][i].controls.app_select_box.value.points)
      }
      console.log(this.formGroup.controls.other_rewards['controls'])
      // if (this.rewardTypeField == 1) {
      //   this.messageField = res.data.e_voucher
      // } else if (this.rewardTypeField == 2) {
      //   this.messageField = res.data.physical_voucher
      // } else if (this.rewardTypeField == 3) {
      //   this.messageField = res.data.mega
      // } else if (this.rewardTypeField == 4) {
      //   this.messageField = res.data.points
      // }

    })
  }
  downloadExcel(){
        let sheetName = "Individual";
        let filename = "reward_Bifurcation";
        let excelData = []
        let excelArray = [
          {
            header: "Qr code",
            key: "Qr code"
          },
        ]
        this.exportExcelService.DownloadstaticReportExcel(filename, sheetName, excelData, excelArray);
      }

      subReward(e,i){
        this.apiService.get(this.apiconfig.rewardTypes+`?program_id=1&reward_type=${e}&id=1`).subscribe((res:any)=>{
          // return res.data.reward_name
          this.formGroup.controls.other_rewards['controls'][i].patchValue({
            type_select_box : res.data
          })
        })

        }

  }



/**
 * @author Ch
 * @description
 */

































